const api = {
	/** ------对账-------- */
	listMerchantBills: '/mallSettlement/listMerchantBills', // 查询店铺商户账单列表
	listMerchantBillDates: '/mallSettlement/listMerchantBillDates', // 查询d店铺结算周期列表
	downloadBillDetail: '/mallSettlement/downloadBillDetail', // 下载结算明细
	getMallBillDetail: '/mallSettlement/getBillDetail',

	storeDetail: '/store/detail', //店铺详情，
	// 查询商家账单列表（储值结算和卡券结算）
	listMerchantCouponAndStoredValueCardBills: '/storedValueCardSettlement/listMerchantCouponAndStoredValueCardBills',
	// 查询商家账单（储值结算和卡券结算）的周期列表
	listMerchantCouponAndStoredValueCardBillDates:
		'/storedValueCardSettlement/listMerchantCouponAndStoredValueCardBillDates',
	// 查询商家账单（储值结算和卡券结算）的结算主体列表
	listMerchantCouponAndStoredValueCardBillOrganizations:
		'/storedValueCardSettlement/listMerchantCouponAndStoredValueCardBillOrganizations',
	// 下载商家所有账单（储值结算和卡券结算）的结算明细
	downloadMerchantAllCouponAndStoredValueCardBillDetail:
		'/storedValueCardSettlement/downloadMerchantAllCouponAndStoredValueCardBillDetail',
	// 确认结算单
	confirmBill: '/storedValueCardSettlement/confirmBill',
	// 商家批量确认账单
	confirmBills: '/storedValueCardSettlement/confirmBills',
	// 下载结算明细
	downloadStoredBillDetail: '/storedValueCardSettlement/downloadBillDetail',
	findMerchantCouponCardBillSetting: '/storedValueCardSettlement/findMerchantCouponBillSetting',
	findMerchantCouponBillSetting: '/couponSettlement/findMerchantCouponBillSetting',
	judgeBillSetting: '/storedValueCardSettlement/judgeBillSetting',
    batchDownloadBillDetail: '/storedValueCardSettlement/batchDownloadBillDetail',
};

const routes = {
	'/shop-settlement': '对账结算',
	'/shop-settlement/bill': '对账单',
	'/shop-settlement/bill/detail': '对账明细',
};

export { api, routes };
